import React, { Component } from "react";
import {
  Row,
  Col,
  DatePicker,
  message,
  Tabs,
  Button,
  Card,
  Typography,
  Modal,
  Spin,
  Checkbox,
  Upload,
  Form,
  Input,
  Select,
} from "antd";
import {
  FileTextOutlined,
  BarChartOutlined,
  PictureOutlined,
  DatabaseOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { config } from "../../config";
import "./DesaCantik.scss";
import localforage from "localforage";

import PieChartComponent from "./Components/Charts/PieChart";
import BarChartComponent from "./Components/Charts/BarChart";
import TableChartComponent from "./Components/Charts/TableChart";
import ContentSection from "./Components/Content";
import LoadingOverlay from "./Components/LoadingOverlay";
import DesaCantikCarousel from "../../component/DesaCantikCarousel";
import Publikasi from "../Publikasi/Publikasi";
import GaleriDesa from "./Components/GaleriDesa/GaleriDesa";
import DesaVideo from "./Components/DesaVideo/DesaVideo";
import Infografik from "../Infografik/Infografik";
import splitBase64Format from "../../utils/splitBase64Format";

const { TabPane } = Tabs;
const { Title, Paragraph } = Typography;
const { Option } = Select;

const CACHE_DURATION = 60 * 60 * 1000;

const jenisDataOptions = [
  "KONDISI GEOGRAFIS",
  "KONDISI PEMERINTAHAN",
  "KONDISI PENDUDUK",
  "KONDISI SOSIAL",
  "KONDISI PERTANIAN",
  "KONDISI PERINDUSTRIAN DAN ENEGI",
  "KONDISI PERDAGANGAN",
  "KONDISI TRANSPORTASI KOMUNIKASI DAN PARIWISATA",
  "LAINNYA",
];

class DesaCantik extends Component {
  state = {
    desaCantikData: null,
    errorMessage: "",
    loading: true,
    renderComplete: false,
    selectedDate: dayjs(),
    videoUrl: null,
    carouselItems: [],
    kegiatan: [],
    showAllSections: false,
    selamatDatangDesaCantik: "", // Tambahkan jika belum ada
    deskripsiDesaCantik: "",
    organizationId: null, // simpan orgId di state
    exportData: [],
    exportLoading: false,
    exportModalVisible: false,
    selectedExportItems: [],
    pemohonanModalVisible: false,
    formPemohonan: {
      alamat: "",
      asalInstansi: "",
      createdBy: "",
      email: "",
      fileSuratPermintaanData: "",
      isactive: "Y",
      jenisData: "",
      nama: "",
      nomorHpWa: "",
      organizationId: "",
      permintaanDataDesaCantikId: "",
      tujuanPenggunaanData: "",
      updatedBy: "",
    },
    fileBase64: null,
    jenisDataSelected: null,
  };

    componentDidMount() {
      this.fetchDashboard(this.state.selectedDate);
    }

    fetchDashboard = async (dateParam) => {
    this.setState({ loading: true, renderComplete: false, selectedDate: dateParam, desaCantikData: null });

    const namaDomain = window.location.href;
    const bulan = dateParam.month() + 1;
    const tahun = dateParam.year();
    const cacheKey = `desacantik_${namaDomain}_${bulan}_${tahun}`;

    // 1. Cek Cache dengan TTL
    try {
      const cached = await localforage.getItem(cacheKey);
      if (cached && cached.data && cached.timestamp) {
        const isExpired = Date.now() - cached.timestamp > CACHE_DURATION;
        if (!isExpired) {
          console.log("✅ Memuat dari cache (Valid):", cacheKey);
          this.setState({ ...cached.data, loading: false, renderComplete: true });
          return;
        }
        console.log("⚠️ Cache expired, mengambil data baru...");
      }
    } catch (err) {
      console.warn("Cache read failed:", err);
    }

    // 2. Fetch API jika cache tidak ada atau expired
    try {
      const orgRes = await axios.get(`${config.BASE_URL}organization/findContentOrganization?namaDomain=${namaDomain}`);
      const dataOrg = orgRes.data?.data;

      if (dataOrg?.organization?.organizationId) {
        const { organization, carousel = [], kegiatan = [] } = dataOrg;
        const { organizationId, linkVideoDesaCantik } = organization;

        const videoUrl = linkVideoDesaCantik ? `https://www.youtube.com/embed/${linkVideoDesaCantik}?autoplay=1` : null;

        const dashboardRes = await axios.get(
          `${config.BASE_URL}DesaCantik/dashboard/findOne/${organizationId}?bulan=${bulan}&tahun=${tahun}`
        );

        const resData = dashboardRes.data?.data;

        const newData = {
          desaCantikData: resData || null,
          organizationId,
          videoUrl,
          carouselItems: carousel,
          kegiatan: kegiatan,
          loading: false,
          renderComplete: true,
          selamatDatangDesaCantik: organization.selamatDatangDesaCantik || "",
          errorMessage: resData ? "" : "Data statistik belum tersedia untuk periode ini.",
        };

        // Simpan ke Cache dengan timestamp
        await localforage.setItem(cacheKey, { timestamp: Date.now(), data: newData });
        this.setState(newData);
      } else {
        this.setState({ loading: false, renderComplete: true, errorMessage: "Organisasi tidak ditemukan" });
      }
    } catch (error) {
      this.setState({ loading: false, renderComplete: true, errorMessage: "Data statistik belum tersedia." });
    }
  };

  handleDateChange = (date) => {
    if (date) this.fetchDashboard(date);
  };

  handleExportSelect = (checkedValues) => {
    this.setState({ selectedExportItems: checkedValues });
  };

  handleExportData = async () => {
    const { selectedExportItems, organizationId, selectedDate } = this.state;

    if (!organizationId) {
      message.error("Organisasi tidak ditemukan");
      return;
    }
    if (
      !Array.isArray(selectedExportItems) ||
      selectedExportItems.length === 0
    ) {
      message.warning("Pilih minimal satu data untuk di-export");
      return;
    }

    if (!selectedDate) {
      message.error("Tanggal belum dipilih");
      return;
    }

    const bulan = selectedDate.month() + 1;
    const tahun = selectedDate.year();

    const payload = {
      organizationId: String(organizationId),
      bulan: Number(bulan),
      tahun: Number(tahun),
      kodeData: selectedExportItems.map(String), // key: kodeData
    };

    // console.log("📦 Export Payload:", payload);

    try {
      const res = await axios.post(
        `${config.BASE_URL}DesaCantik/ExportData/excel`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `ExportDataDesaCantik_${bulan}-${tahun}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();

      message.success("Export data berhasil diunduh");
      this.setState({ exportModalVisible: false });
    } catch (err) {
      if (err.response?.data) {
        const reader = new FileReader();
        reader.onload = () => {
          console.error("❌ Server Error Response:", reader.result);
          message.error(
            `Export gagal: ${reader.result || "Internal Server Error"}`
          );
        };
        reader.readAsText(err.response.data);
      } else {
        console.error("❌ Unexpected Error:", err);
        message.error("Export gagal, silakan coba lagi");
      }
    }
  };

  handleOpenExportModal = async () => {
    const { organizationId, selectedDate } = this.state;
    if (!organizationId) {
      message.error("Organisasi tidak ditemukan");
      return;
    }
    try {
      this.setState({ exportLoading: true, exportModalVisible: true });
      const bulan = selectedDate.month() + 1;
      const tahun = selectedDate.year();
      const res = await axios.get(
        `${config.BASE_URL}DesaCantik/ExportData/kategoriData/${organizationId}?bulan=${bulan}&tahun=${tahun}`
      );
      const kategoriData = Array.isArray(res.data?.data?.kategoriData)
        ? res.data.data.kategoriData
        : [];

      const groupedData = kategoriData.reduce((acc, item) => {
        if (!acc[item.kondisi]) acc[item.kondisi] = [];
        acc[item.kondisi].push(item);
        return acc;
      }, {});

      this.setState({
        exportData: groupedData,
        exportLoading: false,
      });
    } catch (err) {
      this.setState({ exportLoading: false });
      message.error("Gagal memuat data export");
    }
  };

  getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    reader.onerror = (error) => {
      console.error("Error converting file to base64:", error);
      message.error("Gagal mengubah file ke base64");
    };
  };

  renderExportModal = () => {
    const { exportModalVisible, exportData, selectedExportItems } = this.state;

    // Ambil semua kode dari exportData
    const allCodes = Object.values(exportData)
      .flat()
      .map((item) => item.kode);

    const isAllSelected = selectedExportItems.length === allCodes.length;

    const handleSelectAll = (e) => {
      if (e.target.checked) {
        this.setState({ selectedExportItems: allCodes });
      } else {
        this.setState({ selectedExportItems: [] });
      }
    };

    return (
      <Modal
        title="Pilih Data untuk Download"
        open={exportModalVisible}
        onCancel={() => this.setState({ exportModalVisible: false })}
        footer={[
          <Button
            key="cancel"
            onClick={() => this.setState({ exportModalVisible: false })}
          >
            Cancel
          </Button>,
          <Button
            key="export"
            type="primary"
            style={{ backgroundColor: "#FF5722", borderColor: "#FF5722" }}
            onClick={this.handleExportData}
          >
            Export Data
          </Button>,
        ]}
        width={800}
      >
        {/* Checkbox pilih semua */}
        <div style={{ marginBottom: 12 }}>
          <Checkbox
            checked={isAllSelected}
            indeterminate={
              selectedExportItems.length > 0 &&
              selectedExportItems.length < allCodes.length
            }
            onChange={handleSelectAll}
          >
            Pilih Semua
          </Checkbox>
        </div>

        <Checkbox.Group
          style={{ width: "100%" }}
          value={selectedExportItems}
          onChange={(checkedValues) =>
            this.setState({ selectedExportItems: checkedValues })
          }
        >
          {Object.keys(exportData).map((kategori) => (
            <div key={kategori} style={{ marginBottom: 16 }}>
              <strong style={{ display: "block", marginBottom: 8 }}>
                {kategori.toUpperCase()}
              </strong>
              {exportData[kategori].map((item, idx) => (
                <div key={idx} style={{ marginBottom: 4 }}>
                  <Checkbox value={item.kode}>{item.nama}</Checkbox>
                </div>
              ))}
            </div>
          ))}
        </Checkbox.Group>
      </Modal>
    );
  };

  handleDateChange = (date) => {
    if (!date) {
      message.warning("Silakan pilih bulan dan tahun");
      return;
    }
    this.setState({ selectedDate: date }, () => {
      this.fetchDashboard(date);
    });
  };

  handleOpenPemohonanModal = () => {
    this.setState({ pemohonanModalVisible: true, jenisDataSelected: null });
  };

  handleClosePemohonanModal = () => {
    this.setState({ pemohonanModalVisible: false, jenisDataSelected: null });
  };

  handleJenisDataChange = (value) => {
    this.setState({ jenisDataSelected: value });
  };

  handleFileChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      if (!file) return;
      if (file.size > 1024 * 1024) {
        message.error("Ukuran file maksimal 1MB");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        this.setState({ fileBase64: base64 });
      };
      reader.readAsDataURL(file);
    }
  };

  onFinish = (values) => {
    const jenisDataFinal =
      values.jenisData === "LAINNYA"
        ? values.jenisDataLainnya
        : values.jenisData;

    const payload = {
      ...values,
      jenisData: jenisDataFinal,
      fileSuratPermintaanData: this.state.fileBase64 || "",
    };

    // console.log("Submit payload:", payload);

    message.success("Data berhasil dikirim (simulasi)");
    this.closeModal();
  };

  handleSubmitPemohonan = async (values) => {
    try {
      const payload = {
        alamat: values.alamat || "",
        asalInstansi: values.asalInstansi || "",
        createdBy: values.nama || "",
        email: values.email || "",
        fileSuratPermintaanData: this.state.fileBase64 || "",
        isactive: "Y",
        jenisData: values.jenisData || "",
        nama: values.nama || "",
        nomorHpWa: values.nomorHpWa || "",
        organizationId: this.state.organizationId || "",
        tujuanPenggunaanData: values.tujuanPenggunaanData || "",
        updatedBy: values.nama || "",
      };

      // console.log("Payload yang dikirim:", payload);

      await axios.post(`${config.BASE_URL}permintaanDataDesaCantik/create`, [
        payload,
      ]);

      message.success("Permohonan data berhasil dikirim");
      this.setState({ pemohonanModalVisible: false, fileBase64: null });
    } catch (err) {
      console.error("Error saat mengirim permohonan:", err.response);
      message.error("Gagal mengirim permohonan data");
    }
  };

  renderPemohonanModal = () => {
    const { jenisDataSelected } = this.state;
    return (
      <Modal
        title="Form Pemohonan Data Khusus"
        open={this.state.pemohonanModalVisible}
        onCancel={this.handleClosePemohonanModal}
        footer={null}
      >
        <Form layout="vertical" onFinish={this.handleSubmitPemohonan}>
          <Form.Item name="nama" label="Nama" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="alamat" label="Alamat" rules={[{ required: true }]}>
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item name="asalInstansi" label="Asal Instansi">
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ type: "email" }]}>
            <Input />
          </Form.Item>
          <Form.Item
            name="nomorHpWa"
            label="Nomor HP / WA"
            rules={[
              { required: true, message: "Nomor HP/WA wajib diisi!" },
              {
                pattern: /^[0-9]{9,15}$/,
                message: "Nomor HP/WA harus berupa angka dan 9-15 digit",
              },
            ]}
          >
            <Input placeholder="Masukkan nomor HP/WA (tanpa spasi atau tanda)" />
          </Form.Item>

          <Form.Item
            name="jenisData"
            label="Jenis Data"
            rules={[{ required: true, message: "Mohon pilih jenis data" }]}
          >
            <Select
              placeholder="Pilih jenis data"
              onChange={this.handleJenisDataChange}
              allowClear
            >
              {jenisDataOptions.map((item) => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {this.state.jenisDataSelected === "LAINNYA" && (
            <Form.Item
              name="jenisDataLainnya"
              label="Sebutkan Jenis Data"
              rules={[
                { required: true, message: "Mohon isi jenis data lainnya" },
              ]}
            >
              <Input />
            </Form.Item>
          )}
          <Form.Item name="tujuanPenggunaanData" label="Tujuan Penggunaan Data">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item
            name="fileSuratPermintaanData"
            label="Surat Permintaan Data"
          >
            <Upload
              beforeUpload={() => false}
              maxCount={1}
              onChange={this.handleFileChange}
            >
              <Button icon={<UploadOutlined />}>Upload File</Button>
            </Upload>
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ backgroundColor: "#FF5722", borderColor: "#FF5722" }}
          >
            Kirim
          </Button>
        </Form>
      </Modal>
    );
  };

  render() {
    const {
      desaCantikData,
      errorMessage,
      loading,
      selectedDate,
      showAllSections,
      selamatDatangDesaCantik,
      deskripsiDesaCantik,
      organizationId,
    } = this.state;

    const sectionColors = {
      "KONDISI GEOGRAFIS": "#FF5722",
      "KONDISI PEMERINTAHAN": "#FF5722",
      "KONDISI PENDUDUK": "#FF5722",
      "KONDISI SOSIAL": "#FF5722",
      "KONDISI PERTANIAN": "#FF5722",
      "KONDISI PERINDUSTRIAN DAN ENEGI": "#FF5722",
      "KONDISI PERDAGANGAN": "#FF5722",
      "KONDISI TRANSPORTASI KOMUNIKASI DAN PARIWISATA": "#FF5722",
    };

    const sectionsToRender =
      showAllSections || !desaCantikData?.dashboard
        ? desaCantikData?.dashboard
        : desaCantikData.dashboard.slice(0, 3);

    return (
      <section id="desacantik" className="desacantik-wrapper">
        <LoadingOverlay loading={loading} />
        <Card
          style={{
            marginBottom: 15,
            borderRadius: 15,
            background: "linear-gradient(135deg, #f1582e, #f47958)",
            color: "#fff",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          }}
          bodyStyle={{
            padding: 32,
            textAlign: "center",
          }}
        >
          <Title
            level={3}
            style={{
              color: "#fff",
              fontWeight: 600,
            }}
          >
            {selamatDatangDesaCantik ||
              "Selamat Datang di Desa Cinta Statistik (Desa Cantik)"}
          </Title>
        </Card>

        <div className="desacantik-container">
          <Tabs defaultActiveKey="1">
            <TabPane
              tab={
                <span>
                  <BarChartOutlined /> Desa Cantik
                </span>
              }
              key="1"
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} md={16}>
                  <DesaCantikCarousel
                    carouselItems={this.state.carouselItems}
                  />
                </Col>
                <Col xs={24} md={8}>
                  <DesaVideo videoUrl={this.state.videoUrl} />
                </Col>
              </Row>

              <GaleriDesa kegiatan={this.state.kegiatan} />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <DatabaseOutlined /> Data Desa
                </span>
              }
              key="2"
            >
              <Row justify="space-between" style={{ marginBottom: 16 }}>
                <Col>
                  <DatePicker
                    picker="month"
                    value={selectedDate}
                    onChange={this.handleDateChange}
                    format="MMMM YYYY"
                    allowClear={false}
                    style={{ fontSize: 16, height: 38 }}
                  />
                </Col>

                {/* 🔹 Tombol hanya muncul jika data kosong */}
                {Array.isArray(desaCantikData?.dashboard) &&
                  desaCantikData.dashboard.length > 0 && (
                    <Col>
                      <Button
                        type="primary"
                        icon={<DownloadOutlined />} // import ini kalau belum ada
                        style={{
                          backgroundColor: "#FF5722",
                          borderColor: "#FF5722",
                        }}
                        onClick={this.handleOpenExportModal}
                        disabled={!organizationId} // disable kalau orgId null
                      >
                        Download
                      </Button>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#FF5722",
                          borderColor: "#FF5722",
                          marginLeft: "10px",
                        }}
                        onClick={this.handleOpenPemohonanModal}
                        disabled={!organizationId}
                      >
                        Pemohonan Data Khusus
                      </Button>
                    </Col>
                  )}
              </Row>

              {!loading && !desaCantikData && (
                <p className="text-danger text-center">
                  {errorMessage || "Maaf Data Belum Tersedia"}
                </p>
              )}

              {!loading &&
                desaCantikData?.dashboard &&
                sectionsToRender.map((section, sectionIndex) => (
                  <MemoizedContentSection
                    key={`section-${sectionIndex}`}
                    title={section.nama}
                    color={sectionColors[section.nama] || "#FF5722"}
                    details={section.detailDashboard}
                  />
                ))}

              {desaCantikData?.dashboard?.length > 3 && (
                <div style={{ textAlign: "center", marginTop: 16 }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#FF5722",
                      borderColor: "#FF5722",
                    }}
                    onClick={() => {
                      window.requestAnimationFrame(() => {
                        this.setState((prev) => ({
                          showAllSections: !prev.showAllSections,
                        }));
                      });
                    }}
                  >
                    {this.state.showAllSections
                      ? "Sembunyikan Beberapa"
                      : "Lihat Semua"}
                  </Button>
                </div>
              )}
              {this.renderExportModal()}
              {this.renderPemohonanModal()}
            </TabPane>

            <TabPane
              tab={
                <span>
                  <PictureOutlined /> Infografis
                </span>
              }
              key="4"
            >
              <Infografik />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <FileTextOutlined /> Publikasi
                </span>
              }
              key="3"
            >
              <Publikasi />
            </TabPane>
          </Tabs>
        </div>
      </section>
    );
  }
}

const MemoizedContentSection = React.memo(({ title, color, details }) => {
  return (
    <ContentSection title={title} color={color}>
      {details?.map((row, rowIndex) => (
        <Row gutter={[16, 16]} key={`row-${rowIndex}`}>
          {row.detail.map((item) => {
            const colSpan = item.flex || 24;
            return (
              <Col key={item.kode} xs={24} md={colSpan}>
                {item.type === "pie_chart" &&
                  Array.isArray(item.dataSource) &&
                  item.dataSource.length > 0 && (
                    <PieChartComponent
                      title={item.nama ?? "Judul Tidak Tersedia"}
                      dataSource={item.dataSource}
                    />
                  )}

                {item.type === "bar_chart" &&
                  Array.isArray(item.dataSource) &&
                  item.dataSource.length > 0 && (
                    <BarChartComponent
                      title={item.nama ?? "Judul Tidak Tersedia"}
                      dataSource={item.dataSource}
                      labelDataSource={item.labelDataSource ?? []}
                      yAxisLabel={item.label}
                    />
                  )}

                {item.type === "table" && (
                  <TableChartComponent
                    title={item.nama}
                    tableDataSource={item.tableDataSource}
                  />
                )}
              </Col>
            );
          })}
        </Row>
      ))}
    </ContentSection>
  );
});

export default DesaCantik;
